import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function DerechoDeAdmision() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XIX. DERECHO DE ADMISIÓN</h4>
          <br></br>
          <p>
            Parking se reserva el derecho de admisión a los parqueaderos con el fin de garantizar un entorno seguro y ordenado para todos los Usuarios y se basa en los siguientes criterios:
          </p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p>
                <strong>Comportamiento:</strong> Se prohíbe el acceso a personas cuyo comportamiento sea inapropiado, disruptivo o que infrinja las normas establecidas. Esto incluye, pero no se limita a, actitudes agresivas, lenguaje ofensivo, y violaciones a las reglas de conducta del parqueadero.
              </p>
            </li>
            <li>
              <p>
                <strong>Seguridad:</strong> Para mantener la seguridad de nuestros Usuarios y la integridad del parqueadero, nos reservamos el derecho de denegar el acceso a personas que puedan poner en riesgo tanto la seguridad del parqueadero como la seguridad de los operarios y los Usuarios, así como también podrá denegar el acceso a los vehículos que no cumplan con los requisitos de seguridad establecidos, como aquellos en mal estado o que no cuenten con la documentación adecuada.
              </p>
            </li>
            <li>
              <p>
                <strong>Cumplimiento de Normas:</strong> El acceso puede ser restringido a quienes no cumplan con las normas de uso del parqueadero, incluyendo el pago de tarifas, el uso adecuado de los espacios asignados y el respeto a las señales e indicaciones del personal.
              </p>
            </li>
            <li>
              <p>
                <strong>Orden:</strong> Para asegurar el buen funcionamiento del parqueadero y la comodidad de todos los Usuarios, se puede restringir el acceso a vehículos que generen obstrucciones o que no respeten las normas de estacionamiento. Así mismo, se le puede negar el acceso a personas que causen estorbos, molestias, incomodidades o daños a la propiedad de Parking o de otros Usuarios.
              </p>
            </li>
          </ul>
          <p>
            El derecho de admisión se aplica de manera equitativa y de conformidad con la legislación vigente, garantizando que la decisión de admisión no sea discriminatoria por razones de raza, género, religión, orientación sexual, discapacidad, u otras características protegidas por la ley. Parking se reserva el derecho de modificar estos criterios en función de las necesidades operativas y de seguridad.
          </p>
        </Col>
      </Row>
    </Container>
  );
}